import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatPrice = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v ?? 0);

export const CATALOGUES = [
  { key: "tshirts_shorts", emoji: "👕", label: "T-shirts & Shorts" },
  { key: "baskets", emoji: "👟", label: "Baskets" },
  { key: "jeans_pulls", emoji: "👖", label: "Jeans & Pulls" },
  { key: "sacs_luxe", emoji: "👜", label: "Sacs & Sacoches" },
];

export const CATEGORY_LABELS = Object.fromEntries(CATALOGUES.map((c) => [c.key, `${c.emoji} ${c.label}`]));

export const ORDER_STATUS_LABELS = {
  en_attente_paiement: "En attente de paiement",
  payee: "Payée",
  en_preparation: "En préparation",
  expediee: "Expédiée",
  livree: "Livrée",
  annulee: "Annulée",
};
